import Base from './base';


class Case extends Base {

    create(data: any) {
        return this.post('case', data);
    }
    update(case_uid: string,data: any) {
        return this.put(`case/${case_uid}`, data);
    }

    list() {
        return this.get('case/list', {})
    }

    singleCase(case_uid: string) {
        return this.get(`case/${case_uid}`, {});
    }

    deleteCase(case_uid: string) {
        return this.delete(`case/${case_uid}`, {});
    }

    acceptLawyer(data: {
        case_uid: string,
        lawyer_id: number
    }) {
        return this.post('case/accept-lawyer', data)
    }

    rejectLawyer(data: {
        case_uid: string,
        lawyer_id: number
    }) {
        return this.post('case/reject-lawyer', data)
    }

    approveCase(data: {case_uid: string}) {
        return this.post('case/close', data)
    }

    rejectCase(data: {case_uid: string}) {
        return this.post('case/reject', data)
    }

    /**
     * Ask to unmatch the lawyer currently on the case. Allowed only while the case is
     * matched and no work has been done; the lawyer then has 6 business hours to accept
     * or object. Answers with the updated case (status 20).
     */
    rejectAttorney(data: {
        case_uid: string,
        reason: string
    }) {
        return this.post('case/reject-attorney', data)
    }

    /**
     * Re-post a dead case as a new one. Every field is optional and falls back to the
     * parent's. Answers 201 with the NEW case, which carries a NEW case_uid.
     */
    resubmit(case_uid: string, data: {
        price?: number,
        comment?: string,
        date?: string,
        payment_type?: string,
        paymentMethod?: string
    }) {
        return this.post(`case/${case_uid}/resubmit`, data)
    }

}

export default new Case();
